module.exports = __webpack_public_path__ + "img/txtImage@2x.6a928fbc.png";